const results = [
  { icon: 'ri-user-search-line', text: 'Понятный пул потенциальных кандидатов' },
  { icon: 'ri-vip-crown-line', text: 'Подготовленные сотрудники на будущие роли' },
  { icon: 'ri-user-star-line', text: 'Снижение зависимости от срочного внешнего найма' },
  { icon: 'ri-route-line', text: 'Более понятные карьерные траектории' },
  { icon: 'ri-focus-3-line', text: 'Адресное развитие сотрудников' },
  { icon: 'ri-rocket-line', text: 'Развитие управленческого потенциала' },
  { icon: 'ri-archive-line', text: 'Сохранение экспертизы внутри компании' },
  { icon: 'ri-team-line', text: 'Более системная подготовка руководителей' },
  { icon: 'ri-links-line', text: 'Связь оценки, обучения и практики' },
  { icon: 'ri-line-chart-line', text: 'Повышение готовности компании к росту и изменениям' },
];

export default function CompanyResults() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Результат системной работы с кадровым резервом
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${r.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}